import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';
import { OrderModel } from '../models/order.model';
import { OrderDiscountModel } from '../models/order-discount.model';

export class OrderDiscountsApiService extends ApiService {
  static endpoint = 'orders/{order_id}/discounts';

  /**
   * @param {Number|null} discountId
   * @return {String}
   * @protected
   */
  static buildOrderDiscountUrl(orderId, discountId = null) {
    return this.buildUrl(discountId).replace('{order_id}', orderId);
  }

  /**
   * @param {String|Number} orderId
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<OrderDiscountModel>>}
   * @public
   */
  static async getAll(orderId, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildOrderDiscountUrl(orderId), {
      ...config,
      dataModel: OrderDiscountModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} orderId
   * @param {String|Number} discountId
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<OrderDiscountModel>>}
   * @public
   */
  static async get(orderId, discountId, builderCallback = null, config = {}) {
    return HttpApiClient.get(this.buildOrderDiscountUrl(orderId, discountId), {
      ...config,
      dataModel: OrderDiscountModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} orderId
   * @param {Object} data
   * @param {builderCallback} builderCallback
   * @param {Object} config
   * @return {Promise<ApiResponse<OrderModel>>}
   * @public
   */
  static async post(orderId, data, builderCallback = null, config = {}) {
    return HttpApiClient.post(this.buildOrderDiscountUrl(orderId), data, {
      ...config,
      dataModel: OrderModel,
      params: this.prepareUrlBuilder(builderCallback).getUrlParameters(),
    });
  }

  /**
   * @param {String|Number} orderId
   * @param {String|Number} discountId
   * @param {Object} config
   * @return {Promise<HttpResponse>}
   * @public
   */
  static async delete(orderId, discountId, config = {}) {
    return HttpApiClient.delete(this.buildOrderDiscountUrl(orderId, discountId), { ...config });
  }
}
